(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7347],{

/***/ 96387:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/flights/[...all]",
      function () {
        return __webpack_require__(55225);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 55225:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSG": function() { return /* binding */ __N_SSG; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(68239);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(22430);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _Layout_Layout__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(24987);
/* harmony import */ var _components_LandingPage_LandingPage__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(13240);
/* harmony import */ var _utils_httpClient__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(22550);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(14416);







var theme = (0,_mui_material__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
    palette: {
        primary: {
            main: "#00454A"
        },
        secondary: {
            main: "#202020"
        }
    },
    typography: {
        fontFamily: '"Libre Franklin", sans-serif'
    }
});
function FlightLanding(param) {
    var landing = param.landing, // eslint-disable-next-line no-unused-vars
    destination = param.destination, authCompleted = param.authCompleted, recommendation = param.recommendation, yrWeatherWidgetURL = param.yrWeatherWidgetURL, selfUrl = param.selfUrl;
    var userStore = (0,react_redux__WEBPACK_IMPORTED_MODULE_4__/* .useSelector */ .v9)(function(state) {
        return state.user.value;
    });
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(null), currency = ref[0], setCurrency = ref[1];
    var arrival = landing.cityTo || landing.coountryTo || landing.regionTo;
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        if (userStore && arrival) {
            if (userStore.currency !== arrival.currency) {
                (0,_utils_httpClient__WEBPACK_IMPORTED_MODULE_6__/* .httpGet */ .kA)("/api/flight/currency?from=".concat(userStore.currency, "&to=").concat(arrival.currency)).then(function(res) {
                    res.json().then(function(currency) {
                        setCurrency(currency);
                    });
                });
            }
        }
    }, [
        userStore
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
        theme: theme,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_LandingPage_LandingPage__WEBPACK_IMPORTED_MODULE_3__/* .LandingPage */ .f, {
            landing: landing,
            authCompleted: authCompleted,
            recommendation: recommendation,
            yrWeatherWidgetURL: yrWeatherWidgetURL,
            currency: currency,
            selfUrl: selfUrl
        })
    });
}
var __N_SSG = true;
/* harmony default export */ __webpack_exports__["default"] = ((0,_Layout_Layout__WEBPACK_IMPORTED_MODULE_2__/* .withLayout */ .X)(FlightLanding, false));


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [9774,4885,1255,3737,5316,2196,6163,4231,129,1979,7601,9125,2298,3570,9113,2769,6700,632,9780,6420,4987,3766,6154,3240,2888,179], function() { return __webpack_exec__(96387); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);